'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var styles = require('@material-ui/core/styles');
var KeyboardArrowLeft = _interopDefault(require('@material-ui/icons/KeyboardArrowLeft'));
var KeyboardArrowRight = _interopDefault(require('@material-ui/icons/KeyboardArrowRight'));
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var TablePaginationActions = function (props) {
    var theme = styles.useTheme();
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onChangePage = props.onChangePage;
    var handleBackButtonClick = function (event) {
        onChangePage(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onChangePage(event, page + 1);
    };
    var handleSpecificPageClick = function (event) {
        if (event.currentTarget.dataset.value === '...' || !event.currentTarget.dataset.value) {
            return;
        }
        onChangePage(event, parseInt(event.currentTarget.dataset.value, 10) - 1);
    };
    return (React__default.createElement(styledComponents.Main, null,
        React__default.createElement(styledComponents.IconLeftButton, { onClick: handleBackButtonClick, disabled: page <= 0, "aria-label": 'previous page' }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowRight, null) : React__default.createElement(KeyboardArrowLeft, null)),
        utils.buttonValues(page, count, rowsPerPage).map(function (text) {
            return (React__default.createElement(styledComponents.TextButton, { selected: text.goTo === page + 1, key: text.goTo, "data-value": text.goTo, onClick: handleSpecificPageClick }, text.value));
        }),
        React__default.createElement(styledComponents.IconRightButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": 'next page' }, theme.direction === 'rtl' ? React__default.createElement(KeyboardArrowLeft, null) : React__default.createElement(KeyboardArrowRight, null))));
};
var PaginationTableFooter = function (props) {
    var tableColumns = props.tableColumns, totalRows = props.totalRows, rowsPerPage = props.rowsPerPage, handleChangePage = props.handleChangePage, page = props.page, NoResultsComponent = props.NoResultsComponent;
    var fm = reactIntl.useIntl().formatMessage;
    return (React__default.createElement(styledComponents.StyledFooter, null,
        React__default.createElement(styledComponents.StyledTablePagination, { component: 'div', rowsPerPageOptions: [], colSpan: tableColumns, count: totalRows, rowsPerPage: rowsPerPage, page: page, SelectProps: {}, onChangePage: handleChangePage, ActionsComponent: TablePaginationActions, labelDisplayedRows: function () {
                if (totalRows === 0) {
                    return (React__default.createElement(styledComponents.Results, null, NoResultsComponent ? (React__default.createElement(NoResultsComponent, null)) : (React__default.createElement("span", null, fm({ id: 'componentLib.paginationTable.noResults' })))));
                }
                var getResultsInfo = function () {
                    var start = String(page * rowsPerPage + 1);
                    if ((page + 1) * rowsPerPage > totalRows) {
                        return { start: start, end: String(totalRows) };
                    }
                    return { start: start, end: String((page + 1) * rowsPerPage) };
                };
                return (React__default.createElement(styledComponents.Results, null,
                    React__default.createElement(styledComponents.ResultsNumber, null, getResultsInfo().start),
                    React__default.createElement("span", null, " - "),
                    React__default.createElement(styledComponents.ResultsNumber, null, getResultsInfo().end),
                    React__default.createElement("span", null, fm({ id: 'componentLib.paginationTable.of' })),
                    React__default.createElement(styledComponents.ResultsNumber, null, totalRows),
                    React__default.createElement("span", null, fm({ id: 'componentLib.paginationTable.results' }))));
            } })));
};

module.exports = PaginationTableFooter;
